<template>
    <div class="TcInscriptionError inline-block bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all align-middle max-w-xl w-full px-5">
        <div class="py-10">
            <div class="flex flex-col items-center">

                <div class="mx-auto flex-shrink-0 flex items-center justify-center h-16 w-16 rounded-full bg-red-400 text-white">
                    <svg class="h-10 w-10" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                </div>
                <p class="mt-10 text-2xl text-center">Se ha producido un error mientras se intentaba reservar el evento.</p>
                <p class="mt-5 text-gray-500 text-center">{{ $parent.error_msg }}</p>
                <button @click="$parent.setPage($root.user ? 'events-my-calendar':'login-public')" class="w-full max-w-sm mt-10 bg-red-400">Continuar</button>
                <button @click="$root.logOut()" class="w-full max-w-sm mt-5 btn-secondary">Cerar sesión</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'TcInscriptionError',
  data () {
    return {}
  }
}
</script>